import { CoinLayout } from './CoinLayout'
import { withCoinLayout } from './withCoinLayout'

const ConnectedCoinLayout = withCoinLayout(CoinLayout)

export { ConnectedCoinLayout as CoinLayout }
